// src/app/redux/actions/skillsActions.js

export const FETCH_SKILLS_REQUEST = "FETCH_SKILLS_REQUEST";
export const FETCH_SKILLS_SUCCESS = "FETCH_SKILLS_SUCCESS";
export const FETCH_SKILLS_FAIL    = "FETCH_SKILLS_FAIL";

export const FETCH_SKILLS_BY_TYPE_REQUEST = "FETCH_SKILLS_BY_TYPE_REQUEST";
export const FETCH_SKILLS_BY_TYPE_SUCCESS = "FETCH_SKILLS_BY_TYPE_SUCCESS";
export const FETCH_SKILLS_BY_TYPE_FAIL    = "FETCH_SKILLS_BY_TYPE_FAIL";

export const CREATE_SKILL_REQUEST = "CREATE_SKILL_REQUEST";
export const CREATE_SKILL_SUCCESS = "CREATE_SKILL_SUCCESS";
export const CREATE_SKILL_FAIL    = "CREATE_SKILL_FAIL";

export const UPDATE_SKILL_REQUEST = "UPDATE_SKILL_REQUEST";
export const UPDATE_SKILL_SUCCESS = "UPDATE_SKILL_SUCCESS";
export const UPDATE_SKILL_FAIL    = "UPDATE_SKILL_FAIL";

export const DELETE_SKILL_REQUEST = "DELETE_SKILL_REQUEST";
export const DELETE_SKILL_SUCCESS = "DELETE_SKILL_SUCCESS";
export const DELETE_SKILL_FAIL    = "DELETE_SKILL_FAIL";

// Excel
export const DOWNLOAD_SKILLS_TEMPLATE_REQUEST = "DOWNLOAD_SKILLS_TEMPLATE_REQUEST";
export const DOWNLOAD_SKILLS_TEMPLATE_SUCCESS = "DOWNLOAD_SKILLS_TEMPLATE_SUCCESS";
export const DOWNLOAD_SKILLS_TEMPLATE_FAIL    = "DOWNLOAD_SKILLS_TEMPLATE_FAIL";

export const IMPORT_SKILLS_EXCEL_REQUEST  = "IMPORT_SKILLS_EXCEL_REQUEST";
export const IMPORT_SKILLS_EXCEL_SUCCESS  = "IMPORT_SKILLS_EXCEL_SUCCESS";
export const IMPORT_SKILLS_EXCEL_FAIL     = "IMPORT_SKILLS_EXCEL_FAIL";
export const CLEAR_SKILLS_IMPORT_RESULT   = "CLEAR_SKILLS_IMPORT_RESULT";

export const EXPORT_SKILLS_REQUEST = "EXPORT_SKILLS_REQUEST";
export const EXPORT_SKILLS_SUCCESS = "EXPORT_SKILLS_SUCCESS";
export const EXPORT_SKILLS_FAIL    = "EXPORT_SKILLS_FAIL";

export const SET_SKILLS_LOADING      = "SET_SKILLS_LOADING";
export const SET_SKILLS_BULK_LOADING = "SET_SKILLS_BULK_LOADING";
export const CLEAR_SKILLS_ERROR      = "CLEAR_SKILLS_ERROR";

/* =========================
   ACTION CREATORS
========================= */

export const setSkillsLoading      = (loading) => ({ type: SET_SKILLS_LOADING,      payload: loading });
export const setSkillsBulkLoading  = (loading) => ({ type: SET_SKILLS_BULK_LOADING, payload: loading });
export const clearSkillsError      = ()         => ({ type: CLEAR_SKILLS_ERROR });
export const clearSkillsImportResult = ()       => ({ type: CLEAR_SKILLS_IMPORT_RESULT });

// CRUD
export const fetchSkillsRequest = () => ({ type: FETCH_SKILLS_REQUEST });
export const fetchSkillsSuccess = (data)  => ({ type: FETCH_SKILLS_SUCCESS, payload: data });
export const fetchSkillsFail    = (error) => ({ type: FETCH_SKILLS_FAIL,    error });

export const fetchSkillsByTypeRequest = (skillType) => ({ type: FETCH_SKILLS_BY_TYPE_REQUEST, payload: { skillType } });
export const fetchSkillsByTypeSuccess = (data)      => ({ type: FETCH_SKILLS_BY_TYPE_SUCCESS, payload: data });
export const fetchSkillsByTypeFail    = (error)     => ({ type: FETCH_SKILLS_BY_TYPE_FAIL,    payload: error });

export const createSkillRequest = (payload) => ({ type: CREATE_SKILL_REQUEST, payload });
export const createSkillSuccess = (data)    => ({ type: CREATE_SKILL_SUCCESS, payload: data });
export const createSkillFail    = (error)   => ({ type: CREATE_SKILL_FAIL,    error });

export const updateSkillRequest = (id, payload) => ({ type: UPDATE_SKILL_REQUEST, payload: { id, payload } });
export const updateSkillSuccess = (data)        => ({ type: UPDATE_SKILL_SUCCESS, payload: data });
export const updateSkillFail    = (error)       => ({ type: UPDATE_SKILL_FAIL,    error });

export const deleteSkillRequest = (id)   => ({ type: DELETE_SKILL_REQUEST, payload: { id } });
export const deleteSkillSuccess = (id)   => ({ type: DELETE_SKILL_SUCCESS, payload: { id } });
export const deleteSkillFail    = (error) => ({ type: DELETE_SKILL_FAIL,   error });

// Excel
export const downloadSkillsTemplateRequest = () => ({ type: DOWNLOAD_SKILLS_TEMPLATE_REQUEST });

export const importSkillsExcelRequest = (file, { dryRun = true, action = "add" } = {}) => ({
    type: IMPORT_SKILLS_EXCEL_REQUEST,
    payload: { file, dryRun, action },
});

export const exportSkillsRequest = () => ({ type: EXPORT_SKILLS_REQUEST });